import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, ScreenSwitch, PromoBanner, RemoteConfigConsumer } from '@elparking/components'
import ErrorBoundary from 'commons/js/components/ErrorBoundary'
import currentCountry from 'commons/js/country'
import Map from '../../components/Map'
import Sidebar from '../../ui/Sidebar'
import SearchFormContainer from '../../ui/SearchFormContainer'
import SearchForm from '../../components/SearchForm'
import ListContainer from '../../ui/ListContainer'
import MapContainer from '../../ui/MapContainer'
import List from '../../components/List'
import StationCard from '../../components/StationCard'

import MapLoader from '../../ui/MapLoader'
import Content from '../../ui/Content'

import {
    getLatitude,
    getLongitude,
} from './searchLenses'

import { ITV_VEHICLE_FILTERS } from 'commons/js/constants'

const FullSizeContainer = <div style={{height: '100%', width: '100%'}} />
const loadingElement = <MapLoader />

function VehicleInspectionStations ({
    vehicleInspectionStations,
    selectedVehicleInspectionStationId,
    markedVehicleInspectionStationId,
    isLoading,
    error,
    setFormSearch,
    computeDistanceTo,
    buildVehicleInspectionUrl,
    autoCenter,
    searchPoint,
    search,
    setMapSearch,
    disableAutoCenter,
    selectVehicleInspection,
    markVehicleInspection,
}) {
    const { vehicle_filter: VehicleFilter, place } = search
    return (
        <Flex w='100%' flexDirection='column'>
            <ErrorBoundary>
                <RemoteConfigConsumer value='promo_banner_station_search'>
                    {({ active = false,
                        text,
                        link_text: linkText,
                        link_url: linkUrl,
                        enable_on_mobile: showOnMobile,
                        campaign,
                    }) => (
                        active && <Box w='100%'>
                            <PromoBanner
                              text={text}
                              linkText={linkText}
                              linkUrl={linkUrl}
                              showOnMobile={showOnMobile}
                              campaign={campaign}
                              id={`promo-bar-${currentCountry}`}
                            />
                        </Box>
                    )}
                </RemoteConfigConsumer>
            </ErrorBoundary>
            <Flex flex='1' style={{overflow: 'hidden'}}>
                <Sidebar>
                    <SearchFormContainer>
                        <SearchForm onSearch={setFormSearch} vehicleFilter={VehicleFilter} place={place} />
                    </SearchFormContainer>
                    <ListContainer>
                        <List
                          stations={vehicleInspectionStations}
                          selected={selectedVehicleInspectionStationId}
                          marked={markedVehicleInspectionStationId}
                          error={error}
                          onSelect={selectVehicleInspection}
                          isLoading={isLoading}
                          cardComponent={StationCard}
                          computeDistanceTo={computeDistanceTo}
                          buildUrl={buildVehicleInspectionUrl}
                    />
                    </ListContainer>
                </Sidebar>
                <Content>
                    <MapContainer>
                        <ScreenSwitch
                          medium={Map}
                          searchPoint={searchPoint}
                          autoCenter={autoCenter}
                          selected={selectedVehicleInspectionStationId}
                          marked={markedVehicleInspectionStationId}
                          latitude={getLatitude(search)}
                          longitude={getLongitude(search)}
                          stations={vehicleInspectionStations}
                          isLoading={isLoading}
                          containerElement={FullSizeContainer}
                          mapElement={FullSizeContainer}
                          loadingElement={loadingElement}
                          onSearch={setMapSearch}
                          onMark={markVehicleInspection}
                          disableAutoCenter={disableAutoCenter}
                          buildUrl={buildVehicleInspectionUrl}
                        />
                    </MapContainer>
                </Content>
            </Flex>
        </Flex>
    )
}

VehicleInspectionStations.propTypes = {
    search: PropTypes.shape({
        place: PropTypes.shape({
            place_id: PropTypes.string,
        }),
        vehicle_filter: PropTypes.oneOf(ITV_VEHICLE_FILTERS),
    }),
    vehicleInspectionStations: PropTypes.array,
    selectedVehicleInspectionStationId: PropTypes.number,
    markedVehicleInspectionStationId: PropTypes.number,
    isLoading: PropTypes.bool,
    autoCenter: PropTypes.bool,
    error: PropTypes.object,
    searchPoint: PropTypes.object,
    setMapSearch: PropTypes.func,
    setFormSearch: PropTypes.func,
    selectVehicleInspection: PropTypes.func,
    markVehicleInspection: PropTypes.func,
    computeDistanceTo: PropTypes.func,
    buildVehicleInspectionUrl: PropTypes.func,
    disableAutoCenter: PropTypes.func,
}

export default VehicleInspectionStations
